import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16.52 7h-10.52a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h10.52a1 1 0 0 0 .78 -.375l3.7 -4.625l-3.7 -4.625a1 1 0 0 0 -.78 -.375","key":"svg-0"}]]

/**
 * IconLabel
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGFiZWwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE2LjUyIDdoLTEwLjUyYTIgMiAwIDAgMCAtMiAydjZhMiAyIDAgMCAwIDIgMmgxMC41MmExIDEgMCAwIDAgLjc4IC0uMzc1bDMuNyAtNC42MjVsLTMuNyAtNC42MjVhMSAxIDAgMCAwIC0uNzggLS4zNzUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/label
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLabel = createReactComponent('outline', 'label', 'Label', __iconNode);

export default IconLabel;